import React from "react";
import { View, Image, Platform, StatusBar, Text } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { LinearGradient } from "expo-linear-gradient";

import styles from "../styles/profileStyle";
import { setNewUser } from "../../../redux/auth/authSlice";
import { dispatch } from "../../../redux/store";
import dimensions from "../../../globalStyles/dimensions";
import { Colors } from "../../../globalStyles/ColorConfig";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { TouchableOpacity } from "react-native-gesture-handler";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const OnBoardingComplete = () => {
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();

  const handleCompleteProfile = () => {
    dispatch(setNewUser());
  };

  return (
    <View
      style={{
        height: "100%",
        width: "100%",
        paddingBottom: insets.bottom,
      }}
    >
      <StatusBar
        translucent
        backgroundColor={"transparent"}
        barStyle={"light-content"}
      />
      <Image
        source={{
          uri: "https://hushl-spark-dev.s3.ap-south-1.amazonaws.com/frontend-assets/onboarding/explore.webp",
        }}
        resizeMode="cover"
        style={{
          width: "100%",
          height: dimensions.windowHeight / 1.2,
        }}
      />
      <View style={{ position: "absolute", bottom: 0 }}>
        <LinearGradient
          colors={["transparent", "rgba(0,0,0,1)"]}
          style={{
            width: dimensions.windowWidth,
            height: dimensions.windowHeight / 2,
            bottom: 0,
            zIndex: 2,
          }}
        />
        <View
          style={{
            backgroundColor: Colors.black100,
            paddingHorizontal: 16,
            paddingBottom: 10,
          }}
        >
          <Text
            style={[
              styles.showOffText,
              GlobalStyles.heading2,
              {
                color: "white",
                fontFamily: "EBGaramondMedium",
                letterSpacing: -0.3,
                fontSize: 36,
                lineHeight: 38,
                paddingHorizontal: 10,
              },
            ]}
          >
            All done! Let's see who catches your eye.
          </Text>
          <TouchableOpacity
            style={{
              backgroundColor: Colors.black100,
              borderRadius: 40,
              marginVertical: dimensions.marginVertical,
              borderWidth: 0.5,
              borderColor: Colors.grey300,
              justifyContent: "center",
              paddingVertical: 16,
            }}
            onPress={handleCompleteProfile}
          >
            <Text
              style={[
                GlobalStyles.bodyText,
                {
                  color: "#BEBEBE",
                  textAlign: "center",
                  fontFamily: "InterSemiBold",
                  letterSpacing: -0.16,
                },
              ]}
            >
              Explore Spark
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default OnBoardingComplete;
